import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import FeedLogo from "../../FeedPost/component/FeedLogo";
import FeedButton from "../../FeedPost/component/FeedButton";
import {
  FlashMessage,
  Modal,
  ErrorTextHelper,
  Button,

  ConfirmDialog,
} from "../../../../components/common";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { rootReducersState } from "../../../../reducers";
import { ReducerFlag } from "../../../../types/reducer.types";
import {
  deletePostFlagReset,
  updatePostFlagReset,
  editFeedRequest,
  deleteFeedRequest,
} from "../../../../reducers/feeds/feedPost.reducer";
// import { ReactComponent as DeleteIcon } from "../../../../assets/svg/delete-icon.svg";
import dots from "../../../../assets/svg/dots.svg";
import cameraIcon from "../../../../assets/svg/camera.svg";
import Image from "../../../../components/common/Image";
import {
  convertUTCToLocal,
  hasRichTextChanged,
  stripHTMLTags,
  uuid,
} from "../../../../utils/helper";
// import history from "../../../../utils/history";
import { useNavigate } from "react-router-dom";
import appRoutes from "../../../../routes/app.routes";
import { openUrlInNewTab } from "../../../../utils/helper";
import Report from "../../../../components/common/Report";
import { Cancel as CancelOut } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import CommonVideoModal from "../../../../components/common/CoverImage";
import RichTextEditor from "../../../../components/common/PostRichTextEditor";
import LinkPreviewCard, {
  LinkPreviewData,
} from "../../../../components/common/LinkPreviewCard";
import { getLinkPreview } from "../../../../services/feedPage.services";
import {
  dataURLtoBlob,
  generateVideoThumbnails,
} from "../../../../utils/videoThumbnails";
interface FeedListTypes {
  data: any;
  loading?: boolean;
  [key: string]: any;
  index?: any;
  readOnly?: boolean;
  headerUser?: {
    name?: string;
    profile_image?: string;
    isCompany?: boolean;
  };
}

interface MediaAsset {
  id: string;
  media_type: "image" | "video";
  media_thumbnail: string;
  media_original: string;
  thumbnails?: string[];
  selectedCover?: string;
  loadingThumbnails?: boolean;
  thumbnailsGenerated?: boolean;
  thumbnailsCacheKey?: string;
  coverBlob?: Blob;
}

const asPostMediaArray = (pm: unknown): any[] =>
  Array.isArray(pm) ? pm : [];

const linkPreviewFromData = (data: any): LinkPreviewData | null =>
  data?.link_preview_url
    ? {
      url: data.link_preview_url,
      title: data.link_preview_title,
      image: data.link_preview_image,
      domain: data.link_preview_domain,
    }
    : null;

// TODO - recreate this, keep only listing part, rest take out side of the modal, recreating the each and every modal instance
const FeedBodyHeader = ({ data, index, readOnly, headerUser }: FeedListTypes) => {
  const dispatch = useDispatch();
  const {
    editLoading,
    deleteMessage,
    updateFlag,
    updateMessage,
    deleteLoading,
    deleteflag,
    deletePostType,
  } = useSelector(({ postFeed }: rootReducersState) => postFeed.postFeed);
  const currentUser = useSelector(
    ({ session }: rootReducersState) => session.currentUser
  );
  const canEdit = currentUser?.id === data.user_id && !readOnly;
  const headerName = data?.post_user || headerUser?.name || "";
  const headerImage = data?.post_user_image || headerUser?.profile_image || "";
  const headerIsCompany =
    typeof data?.is_company !== "undefined"
      ? data?.is_company
      : headerUser?.isCompany;
  const [feedMore, setFeedMore] = useState<boolean>(false);
  const [openEditFeedModal, setOpenEditFeedModal] = useState<boolean>(false);
  const [closeEditModal, setCloseEditModal] = useState<boolean>(false);
  const [openDeleteFeedModal, setOpenDeleteFeedModal] =
    useState<boolean>(false);
  const [updatedAssets, setUpdatedAssets] = useState<
    {
      id: string;
      file: Blob;
    }[]
  >([]);
  // const [postMedia, setPostMedia] = useState([] );
  const [postMedia, setPostMedia] = useState<MediaAsset[]>(() =>
    asPostMediaArray(data?.post_media).map((m: any) => ({
      id: m.id,
      media_type: m.media_type,
      media_thumbnail: m.media_thumbnail,
      media_original: m.media_original,
      // if the server already has a cover, seed thumbnails + selectedCover
      thumbnails: m.selectedCover ? [m.selectedCover] : undefined,
      selectedCover: m.selectedCover,
      loadingThumbnails: false,
    }))
  );

  const [show, setShow] = useState(false);
  const [currentVideo, setCurrentVideo] = useState<any>(null);
  const feedMoreRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const [deleteMedia, setDeleteMedia] = useState<string[]>([]);
  const [postTextLength, setPostTextLength] = useState<number>(0);
  const [openReport, setOpenReport] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number | null>(
    null
  );
  const [coverModalOpen, setCoverModalOpen] = useState(false);
  const [linkPreviewUrl, setLinkPreviewUrl] = useState<string | null>(
    data?.link_preview_url || null
  );
  const [linkPreview, setLinkPreview] = useState<LinkPreviewData | null>(
    linkPreviewFromData(data)
  );
  const [linkPreviewLoading, setLinkPreviewLoading] = useState(false);
  const linkPreviewRequestRef = useRef<string | null>(null);

  const postId = data?.id;
  // const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  const form = useForm<FeedListTypes>({
    defaultValues: { post_text: data.content || data.post_text },
  });
  const {
    control,
    formState: { errors },
    handleSubmit,
    watch,
    reset,
  } = form;

  const postText = watch("post_text", "");
  const postType = data.post_type;
  const isArticlePost = postType === 1;
  const originalPostText = isArticlePost
    ? data?.article_caption || data?.post_text || ""
    : data?.content || data?.post_text || "";

  // Check the content length
  useEffect(() => {
    const tmpText = stripHTMLTags(postText);
    setPostTextLength(tmpText.length);
  }, [postText]);

  useEffect(() => {
    reset({
      post_text:
        data.post_type === 1
          ? data?.article_caption || data?.post_text || ""
          : data.content || data.post_text || "",
    });
    setPostMedia(
      asPostMediaArray(data.post_media).map((m: any) => ({
        ...m,
        thumbnails: [m.selectedCover || m.media_thumbnail],
        selectedCover: m.selectedCover || m.media_thumbnail,
      }))
    );
    linkPreviewRequestRef.current = null;
    setLinkPreviewUrl(data?.link_preview_url || null);
    setLinkPreview(linkPreviewFromData(data));
    setLinkPreviewLoading(false);
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if ([ReducerFlag.SUCCESS, ReducerFlag.FAILED].includes(deleteflag)) {
      if (deleteflag === ReducerFlag.SUCCESS) {
        setOpenDeleteFeedModal(false);
        navigate("/feeds");
        FlashMessage(
          deletePostType === 1
            ? "Article deleted successfully"
            : "Post deleted successfully"
        );
      } else if (deleteflag === ReducerFlag.FAILED) {
        FlashMessage(deleteMessage, "error");
      }
      resetForm();
      dispatch(deletePostFlagReset());
    }
    // eslint-disable-next-line
  }, [deleteflag]);

  useEffect(() => {
    if ([ReducerFlag.SUCCESS, ReducerFlag.FAILED].includes(updateFlag)) {
      if (updateFlag === ReducerFlag.SUCCESS) {
        setOpenEditFeedModal(false);
      } else if (updateFlag === ReducerFlag.FAILED) {
        FlashMessage(updateMessage, "error");
      }
      resetForm();
      dispatch(updatePostFlagReset());
    }
    // eslint-disable-next-line
  }, [updateFlag]);

  useEffect(() => {
    if (!openEditFeedModal) return;

    const isContentChanged = hasRichTextChanged(postText, originalPostText);
    const isMediaChanged =
      postMedia.length !== asPostMediaArray(data.post_media).length;

    const hasRealCoverChanges = postMedia.some((asset) => {
      if (asset.media_type !== "video") return false;

      const originalAsset = asPostMediaArray(data.post_media).find(
        (m: any) => m.id === asset.id
      );
      if (!originalAsset) return false;

      return (
        asset.selectedCover &&
        asset.selectedCover !== originalAsset.media_thumbnail
      );
    });

    const hasNewMedia = updatedAssets.length > 0;
    const hasDeletedMedia = deleteMedia.length > 0;

    setIsSaveDisabled(
      !(
        isContentChanged ||
        isMediaChanged ||
        hasRealCoverChanges ||
        hasNewMedia ||
        hasDeletedMedia
      )
    );
  }, [
    postText,
    postMedia,
    originalPostText,
    data.post_media,
    updatedAssets,
    deleteMedia,
    openEditFeedModal,
  ]);

  useEffect(() => {
    if (!feedMore) return;

    const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
      if (
        feedMoreRef.current &&
        !feedMoreRef.current.contains(event.target as Node)
      ) {
        setFeedMore(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [feedMore]);

  const feedUpdateDropDown = () => {
    if (feedMore) {
      setFeedMore(false);
    } else {
      setFeedMore(true);
    }
  };

  const removeMedia = (media_id, i) => {
    const _data = (postMedia || []).filter((row) => row.id !== media_id);
    setPostMedia(_data);
    setDeleteMedia((data: string[]) => [...data, media_id]);
    setUpdatedAssets((prevState) => prevState.filter((r) => r.id !== media_id));
  };

  const appendVideoCover = (
    payload: FormData,
    mediaIndex: number,
    asset: MediaAsset,
    filename: string
  ) => {
    const coverBlob =
      asset.coverBlob ||
      (asset.selectedCover?.startsWith("data:")
        ? dataURLtoBlob(asset.selectedCover)
        : null);

    if (coverBlob) {
      payload.append(`cover_media_${mediaIndex}`, coverBlob, filename);
    }
  };

  const onSubmit = (formData: any) => {
    const payload = new FormData();

    // Article posts only update their optional feed caption. Their article
    // media and body are edited from the article editor, not this modal.
    if (isArticlePost) {
      payload.append("post_text", formData.post_text || "");
      payload.append("id", data.id);

      dispatch(
        editFeedRequest({
          id: data.id,
          payloadData: payload,
          data: {
            ...data,
            article_caption: formData.post_text || "",
          },
        })
      );
      return;
    }

    // 1) Handle newly added media files
    let mediaIndex = 1;
    updatedAssets.forEach(({ id, file }) => {
      payload.append(`post_media_${mediaIndex}`, file);

      const asset = postMedia.find((a) => a.id === id);
      if (asset?.media_type === "video") {
        appendVideoCover(payload, mediaIndex, asset, `cover_${id}.jpg`);
      }
      mediaIndex++;
    });

    postMedia.forEach((asset) => {
      if (
        asset.media_type !== "video" ||
        updatedAssets.some((a) => a.id === asset.id)
      )
        return;

      const originalAsset = asPostMediaArray(data.post_media).find(
        (m: any) => m.id === asset.id
      );
      if (!originalAsset) return;

      if (
        asset.selectedCover?.startsWith("data:") &&
        asset.selectedCover !== originalAsset.selectedCover
      ) {
        const coverBlob = dataURLtoBlob(asset.selectedCover);
        const coverIndex = mediaIndex++;

        payload.append(
          `cover_media_${coverIndex}`,
          coverBlob,
          `cover_update_${asset.id}.jpg`
        );

        payload.append(`original_video_${asset.id}`, asset.media_original);
      }
    });

    if (deleteMedia.length) {
      payload.append("deleted_post_media", JSON.stringify(deleteMedia));
    }
    payload.append("post_text", formData.post_text || "");
    payload.append("id", data.id);
    // always send all 4 keys: the backend only writes a link_preview_* field
    // when its key is present, and clears it to null on an empty string, so
    // omitting a key here would leave a stale preview in place after removal.
    payload.append("link_preview_url", linkPreview?.url || "");
    payload.append("link_preview_title", linkPreview?.title || "");
    payload.append("link_preview_image", linkPreview?.image || "");
    payload.append("link_preview_domain", linkPreview?.domain || "");

    dispatch(
      editFeedRequest({
        id: data.id,
        payloadData: payload,
        data: {
          ...data,
          content: formData.post_text,
          post_media: postMedia,
          link_preview_url: linkPreview?.url || null,
          link_preview_title: linkPreview?.title || null,
          link_preview_image: linkPreview?.image || null,
          link_preview_domain: linkPreview?.domain || null,
        },
      })
    );
  };

  const onCloseEditModal = () => {
    if (
      hasRichTextChanged(postText, originalPostText) ||
      postMedia.length !== asPostMediaArray(data.post_media).length ||
      postMedia.some((asset) => {
        if (asset.media_type !== "video") return false;
        const originalAsset = asPostMediaArray(data.post_media).find(
          (m: any) => m.id === asset.id
        );
        return (
          originalAsset &&
          asset.selectedCover &&
          asset.selectedCover !== originalAsset.media_thumbnail
        );
      }) ||
      updatedAssets.length > 0
    ) {
      setCloseEditModal(true);
    } else {
      setOpenEditFeedModal(false);
    }
  };

  const onUpdateMedia = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    // prevent >4 items
    if (postMedia.length + files.length > 4) {
      FlashMessage("Max 4 files can be uploaded", "error");
      e.target.value = "";
      return;
    }

    const newAssets: MediaAsset[] = [];
    for (const file of files) {
      const id = uuid();
      const url = URL.createObjectURL(file);
      const isVideo = file.type.startsWith("video/");
      const asset: MediaAsset = {
        id,
        media_type: isVideo ? "video" : "image",
        media_thumbnail: url,
        media_original: url,
        loadingThumbnails: isVideo,
        thumbnailsGenerated: false,
      };

      if (isVideo) {
        try {
          const thumbs = await generateVideoThumbnails(file);
          asset.thumbnails = thumbs;
          asset.selectedCover = thumbs[0];
          asset.media_thumbnail = thumbs[0];
          asset.coverBlob = dataURLtoBlob(thumbs[0]);
          asset.thumbnailsGenerated = true;
        } catch (error) {
          console.warn("Error generating video thumbnails:", error);
          FlashMessage(
            "Could not generate a video thumbnail automatically. Please use Edit Cover.",
            "warning"
          );
        } finally {
          asset.loadingThumbnails = false;
        }
      }

      newAssets.push(asset);
      setUpdatedAssets((prev) => [...prev, { id, file }]);
    }

    setPostMedia((prev) => [...prev, ...newAssets]);
    e.target.value = "";
  };

  const resetForm = () => {
    setUpdatedAssets([]);
    setDeleteMedia([]);
  };

  const handleUrlPasted = async (url: string) => {
    setLinkPreviewUrl(url);
    setLinkPreviewLoading(true);
    linkPreviewRequestRef.current = url;
    const res: any = await getLinkPreview(url);
    if (linkPreviewRequestRef.current !== url) return; // a newer paste superseded this request
    setLinkPreviewLoading(false);
    if (res.flag && (res.data?.title || res.data?.image)) {
      setLinkPreview({
        url: res.data.url || url,
        title: res.data.title,
        image: res.data.image,
        domain: res.data.domain,
      });
    } else {
      setLinkPreview(null);
    }
  };

  const handleUrlRemoved = () => {
    linkPreviewRequestRef.current = null;
    setLinkPreviewUrl(null);
    setLinkPreview(null);
    setLinkPreviewLoading(false);
  };

  const handelRedirectProfile = () => {
    if (data?.is_company && data?.user_slug) {
      let redirect = "";
      if (data?.is_company === 1) {
        redirect = appRoutes.candidatePublicProfile.generateFullPath(
          data.user_slug
        );
      } else if (data?.is_company === 2) {
        redirect = appRoutes.CompanyPublicView.generatePath(data.user_slug);
      }

      if (redirect) {
        openUrlInNewTab(redirect);
      }
    }
  };

  const handleCoverSelect = async (cover: { time: number; blob: Blob }) => {
    if (currentVideoIndex === null) return;

    try {
      // Convert blob to data URL for preview
      const dataUrl = await new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.readAsDataURL(cover.blob);
      });

      // Update state with both the blob and data URL
      setPostMedia((prev) =>
        prev.map((asset, i) =>
          i === currentVideoIndex
            ? {
              ...asset,
              selectedCover: dataUrl,
              coverBlob: cover.blob,
            }
            : asset
        )
      );

      setShow(false);
    } catch (error) {
      console.error("Error processing cover image:", error);
      FlashMessage("Failed to process cover image", "error");
    }
  };
  return (
    <>
      <div className="feed-header">
        <div
          className="feed-header-info cursor-pointer"
          onClick={() => handelRedirectProfile()}
        >
          <FeedLogo
            profileLogo={headerImage}
            name={headerName}
            isCompany={headerIsCompany}
          />
          <div className="feed-title-info">
            <h5>{headerName}</h5>
            <div className="feed-title-meta">
              {headerIsCompany !== 2 && data?.user?.job_details?.title && (
                <span>{data.user.job_details.title}</span>
              )}
              <span>{convertUTCToLocal(data.created_at)}</span>
            </div>
          </div>
        </div>
        {canEdit ? (
          <div
            ref={feedMoreRef}
            className="feed-header-more"
            onClick={() => feedUpdateDropDown()}
          >
            <Image src={dots} alt="postImage" className="dot-icon" />
            {feedMore && (
              <ul>
                {postType === 1 ? (
                  <>
                    <li
                      onClick={() => {
                        setFeedMore(false);
                        setOpenEditFeedModal(true);
                      }}
                    >
                      Edit post
                    </li>
                    <li
                      onClick={() =>
                        openUrlInNewTab(
                          appRoutes.articleUpdate.generatePath(data?.slug)
                        )
                      }
                    >
                      Edit article
                    </li>
                  </>
                ) : (
                  <li onClick={() => setOpenEditFeedModal(true)}>Edit</li>
                )}
                {/* <li>Hide Post</li> */}

                <li
                  onClick={() => {
                    setOpenDeleteFeedModal(true);
                  }}
                >
                  Delete
                </li>
              </ul>
            )}
          </div>
        ) : (
          <div
            ref={feedMoreRef}
            className="feed-header-more"
            onClick={() => feedUpdateDropDown()}
          >
            <Image src={dots} alt="postImage" className="dot-icon" />
            {feedMore && (
              <ul>
                <li onClick={() => setOpenReport(true)}>Report {postType === 1 ? 'Article' : 'Post'}</li>
              </ul>
            )}
          </div>
        )}
      </div>

      {openReport && (
        <Report
          openReports={true}
          referenceId={postId}
          type="post"
          titleText={`Report this ${postType === 1 ? 'article' : 'post'}`}
          onClose={() => {
            setOpenReport(false);
          }}
        />
      )}
      {/* Edit Feed Modal here  */}
      {openEditFeedModal && !readOnly && (
        <Modal
          className="feed-edit-modal"
          visible={openEditFeedModal}
          closeOnBackDrop={true}
          closeButton={true}
          size="large"
          loading={editLoading}
          title={isArticlePost ? "Edit post" : "Edit Post"}
          onClose={() => onCloseEditModal()}
        >
          <div className="feed-input-wrapper">
            <form onSubmit={handleSubmit(onSubmit)}>
              {isArticlePost && (
                <p className="feed-edit-caption-hint">
                  Add an optional message to show above your article in the
                  feed.
                </p>
              )}
              <div className="modal-textArea wysiwyg-data">
                <RichTextEditor
                  name="post_text"
                  validationObj={errors}
                  control={control}
                  rules={{
                    validate: {
                      validLength: (value) => {
                        const tmpText = stripHTMLTags(value || "");
                        return (
                          tmpText.length <= 3000 ||
                          "Can not exceed more then 3000 characters"
                        );
                      },
                    },
                  }}
                  useMention
                  onUrlPasted={handleUrlPasted}
                  watchUrl={linkPreviewUrl}
                  onUrlRemoved={handleUrlRemoved}
                />
                <FeedLogo
                  profileLogo={data.post_user_image}
                  name={data.post_user}
                  isCompany={data?.is_company}
                />
              </div>
              {_.get(errors, "post_text.message") && (
                <ErrorTextHelper text={_.get(errors, "post_text.message")} />
              )}
              <span className="text-length">{postTextLength}/3000</span>
              {!isArticlePost && (
                <LinkPreviewCard
                  preview={linkPreview}
                  loading={linkPreviewLoading}
                  onRemove={handleUrlRemoved}
                />
              )}
              {!isArticlePost && postMedia?.length > 0 && (
                // <div className="feed-media-wrapper">
                <div className="feed-img-wrapper">
                  {postMedia?.map((media, i) => {
                    return (
                      <div className="img-wrapper" key={i}>
                        {media.media_type === "image" ? (
                          <Image
                            src={media?.media_thumbnail}
                            alt="post media"
                          />
                        ) : media.loadingThumbnails ? (
                          <div className="video-cover-loading">
                            <CircularProgress size={28} />
                          </div>
                        ) : (
                          <>
                            <Image
                              src={media.selectedCover || media.media_thumbnail}
                              alt="video cover"
                            />
                            <span className="play-icon-cover">
                              <i className="fa fa-play"></i>
                            </span>
                            <span
                              onClick={() => {
                                setCurrentVideo(media.media_original);
                                setShow(true);
                                setCurrentVideoIndex(i);
                              }}
                              color="secondary"
                              className="cover-btn"
                            >
                              Edit Cover
                            </span>
                          </>
                        )}
                        <span
                          className="media-close"
                          onClick={() => removeMedia(media.id, i)}
                        >
                          {/* <DeleteIcon /> */}
                          <CancelOut />
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
              <div className="feed-button-wrapper">
                {!isArticlePost && (
                  <FeedButton
                    svg={cameraIcon}
                    id="edit_button"
                    name="post_media"
                    type="file"
                    form={form}
                    onUploadImage={onUpdateMedia}
                    value="post_media"
                    accept="image/png, image/gif, image/bmp, image/jpeg ,video/*"
                  />
                )}
                <div className="edit-btn-wrapper">
                  <Button
                    className="submit-btn"
                    loading={editLoading}
                    disabled={
                      // postText.length > 0 || postMedia.length > 0 ? false : true
                      isSaveDisabled
                    }
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    className="submit-btn"
                    color="secondary"
                    onClick={() => onCloseEditModal()}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </Modal>
      )}

      {/* Edit Feed Modal ends here  */}

      <ConfirmDialog
        visible={closeEditModal}
        title="Discard Feed"
        bodyText="You have unsaved changes. Are you sure you want to discard changes?"
        cancelText="Keep Posting"
        confirmText="Discard"
        onCancel={() => setCloseEditModal(false)}
        onConfirm={() => {
          setCloseEditModal(false);
          setOpenEditFeedModal(false);
          setPostMedia(asPostMediaArray(data.post_media));
        }}
      />

      {coverModalOpen && currentVideoIndex !== null && (
        <Modal
          className="post-cover-modal"
          title="Select Cover Image"
          visible
          onClose={() => setCoverModalOpen(false)}
        >
          {/* <div className="cover-options-container">
            {postMedia[currentVideoIndex].thumbnails!.map((thumb, idx) => (
              <img
                alt="no-cover"
                key={idx}
                src={thumb}
                onClick={() => handleCoverSelect(thumb)}
                className={
                  postMedia[currentVideoIndex].selectedCover === thumb
                    ? "cover-option-img selected"
                    : "cover-option-img"
                }
              />
            ))}
          </div> */}
          <div className="cover-options-container">
            {postMedia[currentVideoIndex].loadingThumbnails ? (
              <CircularProgress
                color="secondary"
                className="circular-progress"
              />
            ) : (
              postMedia[currentVideoIndex].thumbnails?.map((thumb, idx) => (
                <img
                  alt="no-cover"
                  key={idx}
                  src={thumb}
                  onClick={() => handleCoverSelect(thumb)}
                  className={
                    postMedia[currentVideoIndex].selectedCover === thumb
                      ? "cover-option-img selected"
                      : "cover-option-img"
                  }
                />
              ))
            )}
          </div>
        </Modal>
      )}

      {/* Delete Feed Confirm Modal here */}
      <ConfirmDialog
        visible={openDeleteFeedModal}
        title={postType === 1 ? "Remove article" : "Remove post"}
        onCancel={() => setOpenDeleteFeedModal(false)}
        bodyText={
          postType === 1
            ? "Do you really want to remove the article?"
            : "Do you really want to remove the post?"
        }
        onConfirm={() => {
          dispatch(deleteFeedRequest(data.id));
          setOpenDeleteFeedModal(false);
        }}
        loading={deleteLoading}
        confirmText="Confirm"
      />
      {/* Delete Feed Confirm Modal ends here */}
      <CommonVideoModal
        openModal={show}
        videoUrl={currentVideo}
        onClose={() => setShow(false)}
        onCoverSelect={handleCoverSelect}
      />
    </>
  );
};

export default FeedBodyHeader;
